import React from 'react';
import {I18nextProvider, useTranslation} from 'react-i18next';
import i18n from '../../../../../../../i18n/index';
import GuidedToursListPopup from '../../../../../popup/components/guided-tours-list-popup/index';
import SupportDetailsPopup from '../../../../../popup/components/support-details-popup/index';
import Content from '../../../../../content';
import upgradeContent from './upgrade-content';
import {useDispatch, useSelector} from 'react-redux';
import Button from '../../../../../button';
import WarningProgressBar from '../../../../../sprite/components/warning-progress-bar';
import {isConfirmSwitchToFreePopupShown} from '../../../../../../../actions/popupActions';
import './index.css';

function TimedOutPage (props) {

	const {display} = props;
	const {t} = useTranslation();

	const notEligible = useSelector(state => state.retrialEligibleReducer.notEligible);
	const isEligibilityChecking = useSelector(state => state.retrialEligibleReducer.isEligibilityChecking);
	const isTransferringRequest = useSelector(state => state.retrialEligibleReducer.isTransferringRequest);
	const validEligibility = useSelector(state => state.retrialEligibleReducer.validEligibility);

	const dispatch = useDispatch();

	const buyHandler = (e) => {
		e.preventDefault();
		// Use /api/payment so production/staging CDN proxies to the backend
		// (plain /payment/* can be served as the SPA and bounce back).
		window.location.href = '/api/payment/new';
	};

	const contactHandler = () => {
		window.location.href = "mailto:support@getsharedcontacts.com";
	};

	const switchToFreeHandler = () => {
		dispatch(isConfirmSwitchToFreePopupShown(true))
	};

	const displayTimedOutContent = () => {
		if(isTransferringRequest){
			return (
				<div className="text-center">
					<img className="mb-5" src="/img/transferring-request.png" alt="Transferring request"/>
					<WarningProgressBar/>
					<h2>{t('upgradeTemplateExpiredEvalRequestNewTrialTitle')}</h2>
					<p>{t('upgradeTemplateExpiredEvalRequestNewTrialText')}</p>
				</div>
			)
		} else if (notEligible) {
			return (
				<div className="d-flex">
					<img className="mb-5" src="/img/shared-contacts-for-gmail-not-eligible.png" alt="Not eligible"/>
					<div className="ml-5">
						<h2 className="mb-5">{t('upgradeTemplateExpiredEvalNotEligibleForNewTrialTitle')}</h2>
						<p dangerouslySetInnerHTML={{__html:t('upgradeTemplateExpiredEvalNotEligibleForNewTrialText')}} />
						<Button onClick={buyHandler} className="mr-2 btn-primary">{t('textBuy')}</Button>
						<Button onClick={contactHandler} className="btn-outline-primary">{t('contactSupportBtn')}</Button>
					</div>
				</div>
			)
		} else if (isEligibilityChecking) {
			return (
				<div className="text-center">
					<div className="d-flex justify-content-center">
						<img className="thumb-up mr-5 mb-5" src="/img/thumb-up.png" alt="Thumb up"/>
						<img className="thumb-down mb-5" src="/img/thumb-down.png" alt="Thumb down"/>
					</div>
					<WarningProgressBar/>
					<h2>{t('upgradeTemplateExpiredEvalCheckingNewTrialEligibilityTitle')}</h2>
					<p>{t('upgradeTemplateExpiredEvalCheckingNewTrialEligibilityText')}</p>
				</div>
			)
		} else if (validEligibility) {
			return (
				<div className="d-flex">
					<div className="d-flex">
						<img className="mb-5" src="/img/shared-contacts-for-gmail-eligible.png" alt="Eligible"/>
						<div className="ml-5">
							<h2 className="mb-5">{t('upgradeTemplateExpiredEvalEligibleForNewTrialTitle')}</h2>
							<p dangerouslySetInnerHTML={{__html:t('upgradeTemplateExpiredEvalEligibleForNewTrialText')}} />
							<Button onClick={() => window.location.reload()} className="mr-2 btn-primary">{t('accessMyNewFreeTrialBtn')}</Button>
						</div>
					</div>
				</div>
			)
		} else {
			return upgradeContent.filter(item => item.status === display).map( item => {
				return (
					<div className="row" key={item.status}>
						<div className="col-12 col-md-6">
							<img className="w-100 mb-5 mb-md-0" src="/img/shared-contacts-for-gmail-trial-over.png" alt="Trial over"/>
						</div>
						<div className="col-12 col-md-6 d-flex flex-column justify-content-center">
							{item.title && <h2 className="mb-5">{t(item.title)}</h2>}
							<p dangerouslySetInnerHTML={{__html:t(item.text)}} />
							<div className="text-center text-md-left d-flex flex-column flex-md-row">
								<Button onClick={buyHandler} className="btn-primary">{t('textBuy')}</Button>
								<Button onClick={switchToFreeHandler} className="ml-3 btn-outline-primary">{t('switchToFreeBtn')}</Button>
							</div>
						</div>
					</div>
				)
			})
		}

	};

	return (
		<I18nextProvider i18n={i18n}>
			<div className="app expired">
				<GuidedToursListPopup/>
				<SupportDetailsPopup/>
				<Content>
					<div className="container timed-out-page">
						{displayTimedOutContent()}
					</div>
				</Content>
			</div>
		</I18nextProvider>
	)

}

export default TimedOutPage;
